import { getOWAConnectedAccounts } from 'owa-accounts-store';
import getPrimaryAccount from './getPrimaryAccount';

export default function getAllAccounts(): string[] {
    return [getPrimaryAccount(), ...getOWAConnectedAccounts().map(account => account.userIdentity)];
}
